import React from "react";
import { View, TouchableOpacity,ImageBackground,Platform, ScrollView, SafeAreaView, Image} from "react-native";
import { Headline, Paragraph, Button, Surface, ActivityIndicator } from "react-native-paper";
// import BackHandlerAndroid from './../AndroidBackHandler';
// import Icon from "react-native-vector-icons/dist/Ionicons";
// import Icon from 'react-native-vector-icons/MaterialIcons';
// import Icon from 'react-native-vector-icons/FontAwesome';
import { connect } from 'react-redux';
import Toaster from './../../components/snackBar_toaster';
import LoaderComponent from './../../components/LoaderComponent'

import { getTestTermsAndConditions, clearTestTermsAndConditionsData } from './../../store/action';
import moment from 'moment'; 
// import Toast, { DURATION } from 'react-native-easy-toast';
// import Colors from '../Colors';
// import HTML from "react-native-render-html";
// import LinearGradientComponent from './../HeaderBackgroundComponent';
//  import { isIos } from "./../Utils";
//  import StylesColors from './../Colors';
//  import OfflineHandler from './../OfflineHandler';
 import { Text, Styles } from "./../../components/UI-Components";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Header from './../../components/Header';
import Container from '@material-ui/core/Container';

const Loader = require('./../../assets/loadingGif.gif');


class TermsAndConditions extends React.Component {
   state = {
     testId: null,
     isTestSeries: null,
     showToast: false,
      toasterMessage: '',
   } 
  componentDidMount(){
  
    // const testId = this.props.navigation.getParam('testId', null);
    // const plannedTest = this.props.navigation.getParam('plannedTest', false);
    // const isTestSeries = this.props.navigation.getParam('isTestSeries', false);
    const { state={}} = this.props.location;
    const { testId, isTestSeries, isMaterialTest  } = state;
    this.setState({
      testId: testId,
      isTestSeries: isTestSeries,
      isMaterialTest: isMaterialTest
    });
   
    this.props.getTestTermsAndConditions(testId,  false, isTestSeries, isMaterialTest);
  }
   handleChange = (event) => {
    this.setState({ checked: event.target.checked });
  };



  state = {
    checked: false,
  }

  componentWillUnmount() {    
    this.props.clearTestTermsAndConditionsData();
  }
  showToaster = (msg, time, callback) => {
    this.setState({
      showToast: true,
      toasterMessage: msg
    })
  }

  render() {
    const { checked, testId, isTestSeries, isMaterialTest } = this.state;
    const {navigation, loading, error, errorInfo} = this.props;
  
    
    return (
      <>
        <Header
          title="Terms And Conditions"
          headerRight
          headerRightClick={() => this.props.history.push('/Home')}
          headerLeftClick={() => this.props.history.goBack()}
          backButton={true}
      />
      <Container maxWidth='md'>

      
      <div 
        className='main-component'
        // source={require('./../../assets/bg-image.png')} style={{width:'100%',height:'100%'}}
       style={{flex: 1, backgroundColor: Styles.fiveMantraBgColor}}
      >
        {/* <BackHandlerAndroid goBack={(plannedTest || isTestSeries) ? true : false} goToScreen={(plannedTest || isTestSeries) ? null : "MyTests"}/>
        <OfflineHandler /> */}
        {
          loading && <View style={{height:'100%', width:'100%' ,justifyContent:'center', alignItems: 'center'}}>
            
            <Image source={Loader} style={{width: 250, height: 250}}/>
          </View>
        }
        {error && <View
          style={{flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 10}}
        ><Text style={{fontSize: 14, fontWeight: '500'}}>{
          typeof errorInfo === 'string' ? errorInfo : 'something went wrong..'
        }</Text></View>}
        <View style={{flex:1,marginHorizontal:10}}>

      
        <Surface style={{elevation:9,flex:1,marginVertical:40,paddingHorizontal:13,borderRadius:10}}>
      
        <ScrollView style={{flex:1,paddingBottom:30}}>
        <SafeAreaView>
          <View> 


            <View>
            <View style={{marginVertical:10,marginHorizontal:2}}>
                  {/* <Paragraph style={{marginBottom:6,fontSize:10,color:'#848484'}}> */}
                    {/* <Text style={{marginRight:2}}>
                      <Icon color="#848484" name={'circle'} size={4} style={{paddingRight:2,marginBottom:2}}/>
                    </Text> */}
                    {/* <Text style={{fontSize:12,marginLeft:6}}>{this.props._termsAndConditions ? this.props._termsAndConditions :'loading..'}</Text> */}
                  
                  {
                   (this.props._termsAndConditions || this.props.testSeriesTermsAndConditions )
                    &&
                    <>
                            {/* <HTML style={{textAlign:'justify'}} tagsStyles={{h3:{fontWeight:'700',marginVertical:5,
                            textAlign:'justify', fontFamily: 'Lora-Regular'},
                            p:{fontWeight:'400',marginVertical:2, textAlign: 'justify', fontFamily: 'Lora-Regular'}}} html={ this.props._termsAndConditions || this.props.testSeriesTermsAndConditions} />   */}
                            <div dangerouslySetInnerHTML={{__html:this.props.testSeriesTermsAndConditions}}>
                            </div>
                            <View style={{flex:1,justifyContent:'flex-end',marginTop:20}}>
                          <TouchableOpacity 
                            style={{flexDirection: 'row', justifyContent: 'center', alignItems: 'center',marginBottom:10}}
                            onPress={() => { this.setState({ checked: !checked }); }}
                          >
                              <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.checked}
                                  // onChange={this.handleChange}
                                  name="checked"
                                  color="primary"
                                />
                              }
                              
                            />
                            {/* <Checkbox
                              status={checked ? 'checked' : 'unchecked'}
                            /> */}
                            <Text style={{marginLeft: 8,}}>
                              Accept Terms and Conditions 
                            </Text>
                      </TouchableOpacity>
                      <View 
                        style={{justifyContent:'center',textAlign:'center',alignItems:'center'}}
                        >
                        <Button
                          mode="contained"                 
                          onPress={() => this.props.history.push("/TestAttempt", {testId, isTestSeries, isMaterialTest})}
                          disabled={!this.state.checked}
                          style={{alignItems:'center',justifyContent:'center',textAlign:'center',borderRadius:20,backgroundColor:Styles.primaryColor}}>
                          Start Test
                      </Button>
                        </View>
                    </View>
                    </>                    
                //   <View style={{alignItems:'center',justifyContent:'center',flex:1,marginTop:50}}>

                //     <Button
                //     mode="contained"                 
                //     onPress={() => moment(this.props.testStartTime) <= moment(Date.now()) ? this.props.navigation.navigate("TestAttempt", {testId, plannedTest}) : this.refs.toast.show('wait for the exam time', 1000) 
                //   }
                //     disabled={!checked}
                //     style={{alignItems:'center',justifyContent:'center',textAlign:'center',borderRadius:20,backgroundColor:'#F5591F',width:'40%',}}>
                //     Start Test
                // </Button>
                //     </View>

                  }

                {/* </Paragraph> */}
              
                </View>
          </View>


            </View>
            </SafeAreaView>
          </ScrollView>
        </Surface>
        </View>

                {/* <Toast
                  position={Colors.toastPosition}
                  positionValue={180}
                  opacity={1}
                  textStyle={{ color: Colors.toastTextColor }}
                  style={{
                    marginBottom: 50,
                    backgroundColor: Colors.toastBgColor,
                    paddingHorizontal: Colors.toastPaddingHorizontal,
                    borderRadius: 20,
                  }}
                  ref="toast" /> */}
              <Toaster 
                show={this.state.showToast}
                message={this.state.toasterMessage}
                
                />
        </div>
        </Container>
      </>
    )
  }
};

const mapStateToProps = state => ({
  loading: state.testTermsAndConditions && state.testTermsAndConditions.loading,
  error: state.testTermsAndConditions && state.testTermsAndConditions.error,
  errorInfo: state.testTermsAndConditions && state.testTermsAndConditions.errorInfo && state.testTermsAndConditions.errorInfo.data && state.testTermsAndConditions.errorInfo.data.message,
  _termsAndConditions: state.testTermsAndConditions && state.testTermsAndConditions.response && state.testTermsAndConditions.response.terms,
  testSeriesTermsAndConditions: state.testTermsAndConditions && state.testTermsAndConditions.response && state.testTermsAndConditions.response.terms_and_conditions,
  testStartTime: state.testTermsAndConditions && state.testTermsAndConditions.response && state.testTermsAndConditions.response.start_date,
  
})

 export default connect(mapStateToProps,{ getTestTermsAndConditions, clearTestTermsAndConditionsData })(TermsAndConditions);


 